var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34595 -1.97671e-05C0.602488 -1.97671e-05 -0.000205357 0.596934 -0.000205357 1.33331C-0.000205357 2.06969 0.602488 2.66665 1.34595 2.66665H33.6536C34.3971 2.66665 34.9998 2.06969 34.9998 1.33331C34.9998 0.596934 34.3971 -1.97671e-05 33.6536 -1.97671e-05H1.34595ZM1.34595 7.1112C0.602488 7.1112 -0.000205357 7.70815 -0.000205357 8.44453C-0.000205357 9.18091 0.602488 9.77787 1.34595 9.77787H33.6536C34.3971 9.77787 34.9998 9.18091 34.9998 8.44453C34.9998 7.70815 34.3971 7.1112 33.6536 7.1112H1.34595ZM-0.000205357 15.5555C-0.000205357 14.8192 0.602488 14.2222 1.34595 14.2222H33.6536C34.3971 14.2222 34.9998 14.8192 34.9998 15.5555C34.9998 16.2919 34.3971 16.8889 33.6536 16.8889H1.34595C0.602488 16.8889 -0.000205357 16.2919 -0.000205357 15.5555ZM1.34595 21.3333C0.602488 21.3333 -0.000205357 21.9303 -0.000205357 22.6666C-0.000205357 23.403 0.602488 24 1.34595 24H33.6536C34.3971 24 34.9998 23.403 34.9998 22.6666C34.9998 21.9303 34.3971 21.3333 33.6536 21.3333H1.34595Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarButtonIcon);
export default __webpack_public_path__ + "static/media/sidebar-button-icon.25120a067aa1d7d79c86a3ebdd275e7c.svg";
export { ForwardRef as ReactComponent };